import { MutationTree } from 'vuex';
import { EDisconnectResourceMutation } from '@/content-library/disconnect-resource/store/disconnect-resource.constants';
import { IDisconnectResourceState } from '@/content-library/disconnect-resource/store/disconnect-resource.types';
import { IDocumentPage } from '@/types/document-page';

export const mutations: MutationTree<IDisconnectResourceState> = {
  [EDisconnectResourceMutation.SetDisconnecting](
    state: IDisconnectResourceState,
    disconnecting: boolean
  ) {
    state.disconnecting = disconnecting;
  },
  [EDisconnectResourceMutation.SetNewDocumentPage](
    state: IDisconnectResourceState,
    page: IDocumentPage
  ) {
    state.newDocumentPage = page;
  },
  [EDisconnectResourceMutation.SetState](
    state: IDisconnectResourceState,
    newState: IDisconnectResourceState
  ) {
    state.disconnecting = newState.disconnecting;
    state.newDocumentPage = newState.newDocumentPage;
  },
};
